export default __webpack_public_path__ + "static/media/Northword Banners3.b89506e6.jpg";